import { object, string } from 'yup';

export const validationSchema = object().shape({
  phone: string().required('Champ obligatoire').min(10, '10 caractères minimum'),
  email: string().required('Champ obligatoire'),
});
